:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  --color-text-default: #506e81;
  --color-text-hover: #354956;
  --color-text-selected: #002936;
  --color-text-disabled: #99aebb;
  --item-focus-outline-color: #009cc2;
  --badge-color: #ed0007;
  display: inline-block;
}

.meta-nav-button,
.meta-nav-link {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  background: none;
  display: grid;
  grid-auto-flow: row;
  row-gap: 4px;
  align-items: center;
  justify-items: center;
  color: var(--color-text-default);
  padding: 0;
  text-decoration: none;
  cursor: pointer;
}
.meta-nav-button--selected,
.meta-nav-link--selected {
  color: var(--color-text-selected);
}
.meta-nav-button--badge dc-ui-icon,
.meta-nav-link--badge dc-ui-icon {
  position: relative;
}
.meta-nav-button--badge dc-ui-icon::before,
.meta-nav-link--badge dc-ui-icon::before {
  content: "";
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--badge-color);
  border: 1px solid #ffffff;
  background-clip: padding-box;
}
.meta-nav-button:hover,
.meta-nav-link:hover {
  color: var(--color-text-hover);
}
.meta-nav-button:focus-visible,
.meta-nav-link:focus-visible {
  outline: 2px solid var(--item-focus-outline-color);
  outline-offset: 2px;
}
.meta-nav-button--disabled,
.meta-nav-link--disabled {
  pointer-events: none;
  color: var(--color-text-disabled);
}
.meta-nav-button span,
.meta-nav-link span {
  font-family: "Bosch Sans";
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0.038px;
}

:host([disabled]) {
  pointer-events: none;
}

:host([data-in-main-nav]) .meta-nav-button,
:host([data-in-main-nav]) .meta-nav-link {
  display: flex;
  align-items: center;
  -moz-column-gap: 8px;
       column-gap: 8px;
}